<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text">
        {{ $t("fixed-point-network-hfp-lfp-1-3") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>{{ $t("fixed-point-name") }}</td>
                <td>{{ plotItem.FIX_NAM?.split("-")?.[0] }}</td>
              </tr>
              <tr>
                <td>{{ $t("fixed-point-type") }}</td>
                <td>{{ plotItem.FIX_NAM?.split("-").length >= 2 ? plotItem.FIX_NAM?.split("-")?.[1] : "" }}</td>
              </tr>
              <tr>
                <td>{{ $t("distance-to-parcel") }}</td>
                <td>{{ plotItem.FIX_DTP }}</td>
              </tr>
              <tr>
                <td>{{ $t("coordinates") }}</td>
                <td>{{ plotItem.FIX_COO_X }} - {{ plotItem.FIX_COO_Y }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem
}
</script>
